$(window).on("load", function () {
    // Cache the selectors for better performance
    var $sec = $(".feturedJobCont");
    var $container = $(".container");
    var $body = $("body");

    function adjustPadding() {
        // innerWidth() is the jQuery equivalent to clientWidth (includes padding)
        var w = $container.innerWidth();
        var tW = $body.innerWidth();

        console.log($container, w, tW);

        var tgap = tW - w;
        tgap = tgap / 2;
        tgap = tgap + 10;

        $sec.css("padding-left", tgap + "px");
    }

    // Run on page load
    adjustPadding();

    // Run whenever the window is resized
    $(window).on("resize", adjustPadding);
});